var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "alpheios-word-usage" }, [
    _c(
      "div",
      {
        staticClass: "alpheios_word_usage_list_title",
        attrs: { "data-alpheios-ignore": "all" },
      },
      [
        _vm._v(_vm._s(_vm.targetWord) + "\n    "),
        _vm.showHeaderFilters
          ? _c(
              "span",
              {
                staticClass: "alpheios-word-usage-header-show-link",
                on: {
                  click: function ($event) {
                    _vm.collapsedHeader = !_vm.collapsedHeader
                  },
                },
              },
              [_vm._v(" (" + _vm._s(_vm.collapsedHeaderTitle) + ")")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.hasSelectedAuthor
          ? _c("div", { staticClass: "alpheios_word_usage_hint" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.l10n.getText("WORDUSAGE_HINT_FOCUS_SEARCH", {
                      maxResults:
                        _vm.settings.getFeatureOptions().items
                          .wordUsageExamplesMax.currentValue,
                    })
                  ) +
                  "\n    "
              ),
            ])
          : !_vm.hasSelectedAuthor && !_vm.hasSelectedTextWork
          ? _c("div", { staticClass: "alpheios_word_usage_hint" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.l10n.getText("WORDUSAGE_HINT_INITIAL_SEARCH", {
                      maxResults:
                        _vm.settings.getFeatureOptions().items
                          .wordUsageExamplesAuthMax.currentValue,
                    })
                  ) +
                  "\n    "
              ),
            ])
          : _vm._e(),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "alpheios-word-usage-header",
        attrs: { "data-alpheios-ignore": "all" },
      },
      [
        _c("word-usage-examples-filters", {
          attrs: {
            collapsedHeader: _vm.finalCollapsedHeader,
            showHeader: _vm.showHeader,
          },
          on: {
            filterCurrentByAuthor: _vm.filterCurrentByAuthor,
            getMoreResults: _vm.getMoreResults,
            getAllResults: _vm.getAllResults,
          },
        }),
        _vm._v(" "),
        _c("word-usage-examples-sorting", {
          attrs: {
            showHeader: _vm.showHeader,
            collapsedHeader: _vm.finalCollapsedHeader,
            hasSelectedAuthor: _vm.hasSelectedAuthor,
            hasSelectedTextWork: _vm.hasSelectedTextWork,
            reloadSorting: _vm.reloadSorting,
          },
          on: { changedSortBy: _vm.changedSortBy },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _vm.showWordUsageExampleItems
      ? _c(
          "div",
          { staticClass: "alpheios_word_usage_list_mainblock" },
          [
            _vm.wordUsageListSorted.length > 0
              ? [
                  _c(
                    "div",
                    {
                      staticClass:
                        "alpheios-word-usage__examples-show-sources-cbx",
                      attrs: { "data-alpheios-ignore": "all" },
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.showDataSource,
                            expression: "showDataSource",
                          },
                        ],
                        attrs: {
                          id: "alpheios-word-usage-examples-show-sources-cbx-input",
                          type: "checkbox",
                        },
                        domProps: {
                          checked: Array.isArray(_vm.showDataSource)
                            ? _vm._i(_vm.showDataSource, null) > -1
                            : _vm.showDataSource,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.showDataSource,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.showDataSource = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.showDataSource = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.showDataSource = $$c
                            }
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          attrs: {
                            for: "alpheios-word-usage-examples-show-sources-cbx-input",
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.l10n.getText("WORDUSAGE_SHOW_SOURCE_LINKS")
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "alpheios-word-usage__examples",
                      class: {
                        "alpheios-word-usage__examples--sources-visible":
                          _vm.showDataSource,
                      },
                    },
                    [
                      _vm._l(_vm.wordUsageListSorted, function (wordUsageItem) {
                        return [
                          _c("div", {
                            staticClass:
                              "alpheios-word-usage__examples-source-link-large",
                            attrs: { "data-alpheios-ignore": "all" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.formattedFullCit(wordUsageItem)
                              ),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.gotToTheSource(wordUsageItem)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "alpheios-word-usage__examples-pre",
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(wordUsageItem.prefix) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass:
                              "alpheios-word-usage__examples-target-word",
                            domProps: {
                              innerHTML: _vm._s(wordUsageItem.normalizedText),
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "alpheios-word-usage__examples-post",
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(wordUsageItem.suffix) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ]
                      }),
                    ],
                    2
                  ),
                ]
              : [
                  _vm.selectedTextWork
                    ? _c("div", [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.l10n.getText(
                                "WORDUSAGE_HINT_AUTHOR_WORK_FOCUS_SEARCH_NONE",
                                {
                                  maxResults:
                                    _vm.settings.getFeatureOptions().items
                                      .wordUsageExamplesMax,
                                  word: _vm.targetWord,
                                  author: _vm.selectedAuthor.title(),
                                  work: _vm.selectedTextWork.title(),
                                }
                              )
                            ) +
                            "\n      "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.selectedTextWork,
                          expression: "! selectedTextWork",
                        },
                      ],
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.l10n.getText("WORDUSAGE_NO_RESULTS")) +
                          "\n      "
                      ),
                    ]
                  ),
                ],
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.provider,
            expression: "provider",
          },
        ],
        staticClass: "alpheios-word_usage_list__provider",
      },
      [_vm._v("\n    " + _vm._s(_vm.provider) + "\n  ")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }